$(document).ready(function() {
	$('.vid-slider .vid').on('click', function() {
  // get required DOM Elements
  var iframe_src = $(this).children('iframe').attr('src'),
        iframe = $('.video-popup'),
        iframe_video = $('.video-popup iframe'),
        close_btn = $('.close-video');
        iframe_src = iframe_src + '?byline=0&portrait=0&playsinline=0&autoplay=1&autopause=0'; // for autoplaying the popup video
        
  // change the video source with the clicked one
  $(iframe_video).attr('src', iframe_src);
  $(iframe).fadeIn().addClass('show-video');
  $('body').css('overflow', 'hidden'); 
  // remove the video overlay when clicking outside the video
  $(document).on('click', function(e) {
    if($(iframe).is(e.target) || $(close_btn).is(e.target)) {
      $('body').css('overflow', 'auto');
    $(iframe).removeClass('show-video');
    $(close_btn).removeClass('show-video');
    $(iframe_video).attr('src', '');
  }
	});
$(document).ready(function(){
  $(".close-video").click(function(){
    $(".video-popup").removeClass("show-video");
    $('.video-popup.video-modal-wraper').hide();
    $('body').css('overflow', 'auto');
    $(iframe).removeClass('show-video');
    $(close_btn).removeClass('show-video');
    $(iframe_video).attr('src', '');
  });
});
});
  
});